<script setup lang="ts">
import type { CalculatedPrices } from '#shared/types/pricing'

const props = defineProps<{
  prices: CalculatedPrices
  fallback?: string
}>()

const auth = useAuthorizeStore()

const { data: settings, suspense } = useSettings()

await suspense()

const disclaimer = computed(() => {
  let raw: string | undefined
  if (settings.value?.updateSubscription) {
    raw = isConsumer(auth.user)
      ? settings.value?.discountDisclaimer?.consumer
      : settings.value?.discountDisclaimer?.organization
  }

  raw ??= props.fallback

  if (!raw) return

  return interpolate(raw, {
    originalPriceExVat: props.prices === 'NOT_APPLICABLE' ? '' : norwegianPrice(props.prices.original.exVat),
    originalPriceIncVat: props.prices === 'NOT_APPLICABLE' ? '' : norwegianPrice(props.prices.original.incVat),
    recurringStartDate: settings.value?.discountDisclaimer?.recurringStartDate?.toLocaleDateString('nb-NO', {
      month: 'long',
      day: 'numeric',
    }) ?? '',
  })
})
</script>

<template>
  <div v-if="prices !== 'NOT_APPLICABLE' && prices.discounted && disclaimer" class="rounded-md border border-yellow-pop bg-yellow-10 p-legacy-xs text-gray-40">
    <span class="align-top" aria-hidden="true">*&nbsp;</span>
    <span v-text="disclaimer" />
  </div>
</template>
